import { ModalService } from '../modal/modal.service';
import { Injectable } from '@angular/core';
import { ViewModelTypeDecorator } from '../../decorators/view-model-type.decorator';
import { BaseZoomOrchestratorViewModel } from './base-zoom-orchestrator-view-model';
import { ZoomApiClient } from '../../api-clients/zoom/zoom-api-client';
import { UIResultCommand } from '../commands/ui-result-command';
import { ToastMessageService } from '../../components/layout/toast-message/toast-message.service';
import { ZoomAvailablesFilterPipe } from '../../components/zoom/zoom-availables-filter.pipe.ts';
import type { UIResultCommandInterface, ZoomOrchestratorViewModelInterface, ZoomResultInterface } from '@nts/std/interfaces';

@Injectable()
@ViewModelTypeDecorator(ZoomOrchestratorViewModel)
export class ZoomOrchestratorViewModel extends BaseZoomOrchestratorViewModel implements ZoomOrchestratorViewModelInterface {

    modalCommands: Array<UIResultCommandInterface<ZoomResultInterface>> = new Array<UIResultCommand<ZoomResultInterface>>();
    modalTitle = '';
    modalSubtitle = '';
    showFooter = true;
    cancelAction = null; // TODO verificare e sistemare

    constructor(
        apiClient: ZoomApiClient,
        modalService: ModalService,
        toastMessageService: ToastMessageService,
        zoomAvailablesFilterPipe: ZoomAvailablesFilterPipe,
    ) {
        super(apiClient, modalService, toastMessageService, zoomAvailablesFilterPipe);
        this.modalCommands.push(this.results.rowDoubleClickCommand);
    }
}
